@if (authService.getLoader()==true) {
<div class="spinner">
  <div class="lds-roller">
    <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
  </div>
  <h6 style="color:#0F223E;font-size:30px">{{ 'loading' | translate }}</h6>
</div>
}
<div [ngClass]="themeService.selectedTheme" class="mat-app-background" id="theme-container">
  <router-outlet></router-outlet>
</div>